import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import { Today } from '@material-ui/icons';

const SingleDatePicker = ({
  value,
  onChange = ({ target: { name, value } }) => {},
  name = '',
  label = '',
  variant = 'inline',
  inputVariant = 'outlined',
  disableToolbar = true,
  fullWidth = false,
  InputProps = {},
  disabled = false,
  error = false,
  helperText = '',
  size = 'medium',
  add = null,
  ...props
}) => {
  const initialized = useRef(false);
  const { frontEnd = {} } = useSelector(state => state.bizMeta);
  const dateFormat = frontEnd?.dateFormat || 'MM/dd/yyyy';

  const [dateError, setDateError] = useState('');

  function handleChange(newValue, value) {
    if (!value) {
      setDateError('');
      onChange({
        target: {
          name,
          value: ''
        }
      });
      return;
    }
    if (moment(newValue).isValid()) {
      setDateError('');
      onChange({
        target: {
          name,
          value: moment(newValue).format('YYYY-MM-DD')
        }
      });
    } else {
      setDateError('Invalid date format');
    }
  }

  const calculatedValue = () => {
    const hasValue = value !== null && value !== undefined;
    if (add) {
      if (moment(value).isValid()) {
        return moment()
          .add(add.amount || 1, add.unit || 'month')
          .format('YYYY-MM-DD');
      }

      return null;
    }

    if (hasValue && moment(value).isValid()) {
      return value;
    }

    return null;
  };

  useEffect(() => {
    if (
      (!value || value == moment(value).format('YYYY-MM-DD')) &&
      props.default &&
      initialized.current == false
    ) {
      initialized.current = true;
      const temp = moment(value).format('YYYY-MM-DD');
      handleChange(temp, temp);
    }
  }, []);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        autoOk
        variant="inline"
        fullWidth={fullWidth}
        orientation="landscape"
        format={dateFormat}
        label={label}
        inputVariant="outlined"
        value={calculatedValue()}
        onChange={handleChange}
        error={Boolean(dateError) || error}
        helperText={dateError || helperText}
        InputProps={InputProps}
        disabled={disabled}
        KeyboardButtonProps={{ disabled: Boolean(InputProps?.readOnly), size }}
        keyboardIcon={<Today fontSize={size} />}
        size={size}
        views={['year', 'month', 'date']}
        {...props}
      />
    </MuiPickersUtilsProvider>
  );
};

export default SingleDatePicker;
